// extracted by mini-css-extract-plugin
export default {"wrapper":"FontItem_wrapper__wR0JI","wrapperActive":"FontItem_wrapperActive__zjU03","font":"FontItem_font__c4aPp"};